import React from 'react';

type Value = string | number;
interface Props {
    name?: string;
    checked: boolean;
    value?: Value;
    onChange: (payload: { value: Value; checked: boolean }) => void;
}

const Checkbox: React.SFC<Props> = ({ name, checked, value, children, onChange }) => {
    return (
        <label className="checkbox">
            <input
                name={name}
                className="checkbox__input"
                type="checkbox"
                value={value}
                checked={checked}
                onChange={e => onChange({ value: e.target.value, checked: e.target.checked })}
            />
            <span className="checkbox__text">{children}</span>
        </label>
    );
};

export default Checkbox;
